const CSV_MIME_TYPES = new Set([
    'text/csv',
    'application/csv',
    'text/comma-separated-values',
    'application/vnd.ms-excel',
    'text/plain',
]);

export function isPdfFile(file: File): boolean {
    if (/\.pdf$/i.test(file.name)) {
        return true;
    }

    return file.type === 'application/pdf';
}

export function isCsvFile(file: File): boolean {
    if (/\.csv$/i.test(file.name)) {
        return true;
    }

    return CSV_MIME_TYPES.has(file.type);
}
